/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import { ToolsDashbord, ForwardedMapRender, MarkerPoint } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { DamsServices, IDamsList } from '../../services/api/dams/DamServices';
import { Loadin } from '../../components/shared';
import { useAuthContext } from '../../context';

export const LocationsDan = () => {
    // eslint-disable-next-line
    const iconeSVG = "<svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px' fill='#e8eaed'><path d='M80-240v-80q38 0 56.5-20t77.5-20q59 0 77.5 20t54.5 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20q38 0 55.5-20t76.5-20q59 0 77.5 20t56.5 20v80q-57 0-77.5-20T746-280q-36 0-54.5 20T614-240q-57 0-77.5-20T480-280q-38 0-56.5 20T346-240q-59 0-76.5-20T214-280q-38 0-56.5 20T80-240Zm0-160v-80q38 0 56.5-20t77.5-20q57 0 76.5 20t55.5 20q38 0 56.5-20t77.5-20q57 0 77 20t55 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20v80q-59 0-78.5-20T746-440q-36 0-54.5 20T614-400q-57 0-77.5-20T480-440q-38 0-55.5 20T348-400q-59 0-78.5-20T214-440q-36 0-56.5 20T80-400Zm0-160v-80q38 0 56.5-20t77.5-20q57 0 76.5 20t55.5 20q38 0 56.5-20t77.5-20q57 0 77 20t55 20q38 0 56.5-20t77.5-20q57 0 77.5 20t56.5 20v80q-59 0-78.5-20T746-600q-36 0-54.5 20T614-560q-57 0-77.5-20T480-600q-38 0-55.5 20T348-560q-59 0-78.5-20T214-600q-36 0-56.5 20T80-560Z'/></svg>";


    const [ data, setData ] = useState<IDamsList[]>();
    const [ markers, setMarkers ] = useState<MarkerPoint[]>();
    const { userData } = useAuthContext();

    // function getMarker(data: any[]): MarkerPoint[] {
    //     return data.map((marker) => {
    //         const uuid
    //         const position: [number, number] = [marker.latitude, marker.longitude];
    //         const route =  `/information_dam/${uuid}`;
    //         const showMarker = true;
    //         const title = marker.nome;
    //         // eslint-disable-next-line
    //         return { uuid, position, route, showMarker, title, icone };
    //     });
    // }

    function getMarker(data: any[]): MarkerPoint[] {
      return data.map((dam) => {
          const uuid: string = dam.uuid;
          const position: [number, number] = [dam.latitude, dam.longitude];
          const title: string = dam.nome;
          const type = 'barragem';
          const icone = iconeSVG;
          const route =  `/information_dam/${uuid}`;
          const showMarker = true;
          return { uuid, position, title, type, route, showMarker, icone };
      });
  }

    useEffect(() => {
      fetchData();
    }, []);

    const fetchData = () => {
        DamsServices.get(userData.id_empresa)
          .then((response) => {
            if(response instanceof Error){
              console.log(response.message);
            }else{
              const activeDans = response.filter(dam => dam.status === true);
              const newMarkers = getMarker(activeDans);
              setMarkers(newMarkers);
              setData(response);
            }
        });
    };

      if( data == undefined) {
        return(
            <Loadin />
        );
      }
      

    return (
       <LayoutBase 
            title='Localização das Estruturas'
            tollBar={(
                <ToolsDashbord
                />
            )}
        >
            <Box margin={0} display={'flex'} flexDirection={'column'}>
                <ForwardedMapRender
                    type='satelite'
                    show={false}
                    center={[-12.521923252021343, -51.425745155051]}
                    markerPoints={markers}
                    isLocation={true}
                    zoom={4}
                    damName=''
                />

            </Box>
       </LayoutBase>
    );
};